<template><section><h2>Tooltip</h2>
<p>当实例化 <code v-pre>chart</code> 后，向 <code v-pre>chart</code> 添加 <code v-pre>Tooltip</code> 插件即可，<code v-pre>chart.append(new Tooltip())</code>。</p>
<block-demo tip="" source="const data = [1, 2, 3, 4, 5].map(num =&gt; {
  return { value: num }
})

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
})

chart.source(data, { value: &#39;value&#39; })

const pie = new Pie()

const tooltip = new Tooltip({ formatter: d =&gt; d.value })

chart.append([pie, tooltip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [<span class="hljs-number">1</span>, <span class="hljs-number">2</span>, <span class="hljs-number">3</span>, <span class="hljs-number">4</span>, <span class="hljs-number">5</span>].map(<span class="hljs-function"><span class="hljs-params">num</span> =&gt;</span> {
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">value</span>: num }
})

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
})

chart.source(data, { <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span> })

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie()

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip({ <span class="hljs-attr">formatter</span>: <span class="hljs-function"><span class="hljs-params">d</span> =&gt;</span> d.value })

chart.append([pie, tooltip])
</code></pre>
</block-demo><h3>属性</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>String | Function</td>
<td><code v-pre>null</code></td>
<td>标题</td>
</tr>
<tr>
<td>formatter</td>
<td>Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>除标题外，其他文本格式化函数</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>